import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_ORG_LIST',
    url: '/api/system/org?is_complete_tree=1',
    manual: false,
  });
  return [data || [], exec, isRequestSuccessed];
});
